import {useContext} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import {makeStyles} from '@material-ui/core';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import {ValidationContext} from 'shared/useValidation';
import {useTranslation} from 'react-i18next';

const useStyles = makeStyles(theme => ({
  root: {
    '& .MuiDialogContent-root': {
      padding: '20px 24px',

    },
    '& .MuiDialogActions-root': {
      paddingLeft: '24px',
      paddingRight: '24px'
    }
  },

}));

export default function DeletionConfirmationDialog({open, onClose, itemName, text}) {
  const [t] = useTranslation();
  const classes = useStyles();
  const {getDeleteProp} = useContext(ValidationContext);
  return (
    <Dialog className={classes.root} onClose={onClose} open={open}>
      <DialogTitle disableTypography>
        <Typography variant="h1">{t('modal.removeItem.title')}</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography>{text ? text : t('modal.removeItem.body', {name: itemName})}</Typography>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          variant="outlined"
          onClick={onClose}
        >
          {t('modal.removeItem.no')}
        </Button>
        <Button
          color="secondary"
          variant="contained"
          {...getDeleteProp()}
        >
          {t('modal.removeItem.yes')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
